import { useSelector } from "react-redux";
import { Col, Container, Row } from "reactstrap";
import RegisterFree from "../../components/RegisterFree";
import { getLocalization } from "../../redux/localization";
const HeaderSection = () => {
  const t = useSelector(getLocalization);
  return (
    <section className="hero__section">
      <Container className="h-100">
        <Row className="w-100 h-100 d-flex flex-column align-items-center justify-content-center">
          <Col md={9}>
            <h1>Rentificial
            <p className="subheader">Smart Car Rental Manangement Software</p></h1>
            
            <p>
              {t.getString(
                "With this rental software you can track all rental operations from a single point"
              )}
            </p>
            <RegisterFree />
          </Col>
        </Row>
      </Container>
    </section>
  );
};
export default HeaderSection;
